export default "//static.tradera.net/touchweb/static/output/images/category-toys-childrens-items.3fd07688.svg";